export default function isValid(text) {
  if (text.length < 4) return false;
  return true;
}
